(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/game-list-new/assets/javascripts/column-components/game-buy-share-button.js') >= 0) return;  svs.modules.push('/components/marketplace/game-list-new/assets/javascripts/column-components/game-buy-share-button.js');

'use strict';

const GameBuyShareButton = _ref => {
  let activatedDrawId = _ref.activatedDrawId,
    containerId = _ref.containerId,
    game = _ref.game,
    groupId = _ref.groupId,
    memberId = _ref.memberId,
    _ref$hasSelectNumberO = _ref.hasSelectNumberOfShares,
    hasSelectNumberOfShares = _ref$hasSelectNumberO === void 0 ? false : _ref$hasSelectNumberO,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  const baseClassName = 'game-buy-share-button';
  const combinedClassName = "".concat(baseClassName, " ").concat(className).trim();
  return React.createElement(svs.components.marketplace.fractionPayment.FractionPayment, {
    activatedDrawId: activatedDrawId,
    className: combinedClassName,
    containerId: containerId,
    game: game,
    groupId: groupId,
    hasSelectNumberOfShares: hasSelectNumberOfShares,
    isSmall: true,
    memberId: memberId
  });
};
setGlobal('svs.components.marketplace.gameListNew.columnComponents.GameBuyShareButton', GameBuyShareButton);

 })(window);